import { DiscordActivityPlatformApi, Platform, WebPlatformApi } from '@tofu/platform';
import { AuthController } from '../../types/auth-controller';
import { DiscordActivityAuthController } from './discord-activity-auth-controller';
import { WebAuthController } from './web-auth-controller';

interface PlatformApiMap {
  [Platform.DiscordActivity]: DiscordActivityPlatformApi;
  [Platform.Web]: WebPlatformApi;
}

type AuthControllerConstructor<P extends Platform> = new (platform: PlatformApiMap[P]) => AuthController;

const authControllerRegistry: { [P in Platform]: AuthControllerConstructor<P> } = {
  [Platform.DiscordActivity]: DiscordActivityAuthController,
  [Platform.Web]: WebAuthController,
};

export class AuthControllerFactory {
  static create<P extends Platform>({ platform }: { platform: PlatformApiMap[P] }): AuthController {
    const authController = authControllerRegistry[platform.platform] as AuthControllerConstructor<P>;
    if (!authController) {
      throw new Error(`Unsupported platform: ${platform.platform}`);
    }
    return new authController(platform);
  }
}
